import { render, staticRenderFns } from "./RecipientList.vue?vue&type=template&id=6c60504e"
import script from "./RecipientList.ts?vue&type=script&lang=ts&external"
export * from "./RecipientList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports